/* eslint-disable complexity */
import { RoundsCore } from '../../../../core/collections';
import { Round } from '../../models';
import _ from "lodash";

const IS_FINAL_AVAILABLE = true;

export class Rounds extends RoundsCore {
	initialize(){
		this.prefix = 'nrl/';
		this.url = 'rounds.json';
	}

	get isFinal() {
		return this.final_matches.length;
		// return this.getActualRound().get('status') === 'complete';
	}

	setFinalRound() {
		const final_rounds = [
			new Round({
				id:        28,
				is_bye:    0,
				is_final:  1,
				matches: IS_FINAL_AVAILABLE ? this.final_matches[0] : [],
				status: "complete"
			}),
			new Round({
				id:        29,
				is_bye:    0,
				is_final:  1,
				matches: IS_FINAL_AVAILABLE ? this.final_matches[1] : [],
				status: "complete"
			}),
			new Round({
				id:        30,
				is_bye:    0,
				is_final:  1,
				matches: IS_FINAL_AVAILABLE ? this.final_matches[2] : [],
				status: "complete"
			}),
			new Round({
				id:        31,
				is_bye:    0,
				is_final:  1,
				matches: IS_FINAL_AVAILABLE ? this.final_matches[3] : [],
				status:  "complete"
			}),
		];
		if(this.final_matches.length){
			final_rounds.forEach(final => {
				this.add(final)
			})
		}
		return this;
	}

	setFinalRoundAsComplete() {
		const isFinalFinished = this.setFinalRound().get(this.last()).get('status');
		if(isFinalFinished === 'complete'){
			this.setFinalRound().get(this.last()).set({
				status: 'complete'
			});
			return this;
		}
		return this;
	}

	/**
	 * Update model rounds field with filtered rounds
	 * @param isOnByeRounds
	 * @param onlyFuture - if we need only future rounds
	 * @param start_round - league start_round
	 * @param end_round - league end_round
	 * @param is_like_array - if we need to get rounds array, not models
	 * @returns {object} rounds
	 */
	recalculateRounds(isOnByeRounds, onlyFuture = true, {
		start_round = false, end_round = false, is_like_array = false
	} = {}, excludeFinals=false) {
		let rounds = ( onlyFuture ) ? this.onlyFutureRounds() : this;
		
		// rounds = this.withoutByeRounds(rounds, isOnByeRounds);

		if (start_round && end_round) {
			rounds = rounds.filter(function(round) {
				return round.get('id') >= start_round && round.get('id') <= end_round;
			});
		}


		if (is_like_array) {
			rounds = _.map(rounds, round => round.toJSON());
		}
		if(excludeFinals){
			rounds = rounds.filter(round => round.get("id") < 28);
		}
		return rounds;
	}

	get final_matches() {
		// return [];
		// TODO: Need to update this static final rounds
		return [[
			{
				id: 9999991,
				round_name: "Finals week 1",
				status: "tbc",
				final_name: "Finals Week 1",
				home_squad_name: "1st - TBC",
				away_squad_name: "4th - TBC",
			},
			{
				id: 9999992,
				round_name: "Finals week 1",
				status: "tbc",
				final_name: "Finals Week 1",
				home_squad_name: "2nd - TBC",
				away_squad_name: "3rd - TBC",
			},
			{
				id: 9999993,
				round_name: "Finals week 1",
				status: "tbc",
				final_name: "Finals Week 1",
				home_squad_name: "5th - TBC",
				away_squad_name: "8th - TBC",
			},
			{
				id: 9999994,
				round_name: "Finals week 1",
				status: "tbc",
				final_name: "Finals Week 1",
				home_squad_name: "6th - TBC",
				away_squad_name: "7th - TBC",
			},
		],
		[
			{
				id: 9999995,
				round_name: "Semi Finals",
				final_name: "Finals Week 2",
				status: "tbc",
				home_squad_name: "Loser of QF1",
				away_squad_name: "Winner of EF1",
			},
			{
				id: 9999996,
				round_name: "Semi Finals",
				final_name: "Finals Week 2",
				home_squad_name: "Loser of QF2",
				away_squad_name: "Winner of EF2",
				status: "tbc",
			},
		],
		[
			{
				id: 9999997,
				round_name: "Preliminary Finals",
				final_name: "Finals Week 3",
				home_squad_name: "Winner of QF1",
				away_squad_name: "Winner of SF2",
				status: "tbc"
			},
			{
				id: 9999998,
				round_name: "Preliminary Finals",
				final_name: "Finals Week 3",
				home_squad_name: "Winner of QF2",
				away_squad_name: "Winner of SF1",
				status: "tbc"
			},
		],
		[
			{
				id: 9999999,
				round_name: "Grand Final",
				final_name: "Grand Final",
				home_squad_name: "Winner of PF1",
				away_squad_name: "Winner of PF2",
				is_margin_game: true,
				status: "tbc"
			}
		]
		];
	}
}

export default Rounds;